import {_request, _requestForm} from "./api";

export const add = (date) => {
    let params = date

    return new Promise((resolve, reject) => {
        return _requestForm({
            target: 'user', method: 'POST', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const edit = (date,user_guid) => {
    let params = date

    console.log('params',params);

    return new Promise((resolve, reject) => {
        return _requestForm({
            target: `user/${user_guid}`, method: 'PUT', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const remove = (user_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `user/${user_guid}`, method: 'DELETE'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const item = (date) => {
    let params = date;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'user/item', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const activation = (date) => {
    let params = date;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'user/activation', method: 'POST', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const list = (date) => {
    let params = date;
    console.log('params',params)
    return new Promise((resolve, reject) => {
        return _request({
            target: 'user', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const confirm = (date) => {
    let params = date;
    console.log('confirm params',params)
    return new Promise((resolve, reject) => {
        return _request({
            target: 'user/confirm', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const isActivation = (date) => {
    let params = date;
    console.log('confirm params',params)
    return new Promise((resolve, reject) => {
        return _request({
            target: 'user/is-activation', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};



export const listRoleType = (date) => {
    let params = date;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'user/role', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};


export const listStatus = (date) => {
    let params = date;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'user/status', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const listActivationType = (date) => {
    let params = date;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'user/activation-types', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};


export const login = (date) => {
    let params = date;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'user/login', method: 'POST', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const resetPassword = (date) => {
    let params = date
    console.log('>>> params', params);
    return new Promise((resolve, reject) => {
        return _request({
            target: `user/reset-password`, method: 'POST', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};


export const forgotPassword = (date) => {
    let params = date
    console.log('>>> params', params);
    return new Promise((resolve, reject) => {
        return _request({
            target: `user/forgot-password`, method: 'POST', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};
